import {useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {successToast} from "@/composables/useToasts";

const useActionSettings = () => {
  const minuteOptions = {
    60: '1 hour',
    120: '2 hours',
    180: '3 hours',
    240: '4 hours',
    300: '5 hours',
    360: '6 hours',
    420: '7 hours',
    480: '8 hours',
    540: '9 hours',
    600: '10 hours',
    900: '15 hours',
    1200: '20 hours',
    1500: '25 hours',
    1800: '30 hours',
    2100: '35 hours',
    2400: '40 hours',
    2700: '45 hours',
    3000: '50 hours',
  };

  const queryClient = useQueryClient();

  const saveSettingsMutation = useMutation({
    mutationFn: async (data) => await axios.post('/ajax/v2/actions/settings', data),
    onSuccess: () => successToast('Your action settings have been updated.'),
    onError: () => {
      throw new Error('Something went wrong');
    },
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: ['action-setting-details']});
      queryClient.invalidateQueries({queryKey: ['action-progress']});
    },
  });

  const settingsQuery = useQuery({
    queryKey: ['action-setting-details'],
    queryFn: async () => {
      const response = await axios.get('/ajax/v2/actions/settings');

      return response.data.data;
    }
  });

  return {
    minuteOptions,
    saveSettingsMutation,
    settingsQuery,
  };
};

export default useActionSettings;
